import type {
  PermissionType,
  PermissionStrategy,
  PlatformContext
} from '../types'
import { MicrophoneStrategy } from './microphone.strategy'
import { NotificationsStrategy } from './notifications.strategy'
import { ContactsStrategy } from './contacts.strategy'

  type StrategyConstructor = new (context: PlatformContext) => PermissionStrategy

const strategyRegistry = new Map<PermissionType, StrategyConstructor>()

strategyRegistry.set('microphone', MicrophoneStrategy)
strategyRegistry.set('notifications', NotificationsStrategy)
strategyRegistry.set('contacts', ContactsStrategy)

export function createStrategy (
  type: PermissionType,
  context: PlatformContext
): PermissionStrategy | null {
  const Constructor = strategyRegistry.get(type)
  if (!Constructor) {
    return null
  }
  return new Constructor(context)
}

export function registerStrategy (
  type: PermissionType,
  constructor: StrategyConstructor
): void {
  strategyRegistry.set(type, constructor)
}

export function getRegisteredTypes (): PermissionType[] {
  return Array.from(strategyRegistry.keys())
}

export { MicrophoneStrategy, NotificationsStrategy, ContactsStrategy }
